import { createFormState, required } from "redux-freeform";
import { HCAPTCHA } from "../../constants/data_constants";

const formState = {
  captchaToken: {
    validators: [required()]
  },
  // The captcha provider is used to determine which captcha service to use
  // (e.g., hCaptcha, turnstile). This is necessary for the backend to validate.
  captchaProvider: {
    defaultValue: HCAPTCHA,
    validators: [required()]
  }
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formState
);
